<mat-toolbar class="main-toolbar mat-elevation-z6">
  <button class="logo" mat-button [routerLink]="'/'">EnGo</button>
  <ng-container *ngIf="(connStatus$ | async) as connStatus">
    <div *ngIf="!connStatus.netStatus || connStatus.offlineMode" class="offline-bar">
      <mat-icon>wifi_off</mat-icon>
      OFFLINE</div>
    <div class="flex-wrapper">
    <mat-icon
      class="rotate"
      *ngIf="connectionStatusService.syncStatus$ | async"
      matTooltipPosition="below"
      [matTooltip]="'OFFLINE_DATA_DOWNLOADING' | translate"
    >
      rotate_right
    </mat-icon>
<div *ngIf="connStatus.netStatus">
      <timer *ngIf="store.hasAccess()"></timer>
    </div>
    <mat-slide-toggle *ngIf="isMobile" [checked]="!connStatus.offlineMode" (change)="toggleOfflineMode($event)"></mat-slide-toggle>
    <button class="menu-btn" mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>menu</mat-icon>
    </button>
  </div>
  </ng-container>

  <mat-menu #menu="matMenu">
    <button
      *ngFor="let item of store.toolbarMenu"
      mat-menu-item
      [routerLink]="item.link"
    >
      <mat-icon *ngIf="item.icon" class="material-icons-outlined" [fontIcon]="item.icon"></mat-icon>
      <span>{{ item.labelKey | translate }} <ng-container *ngIf="item.extraLabel"> ({{ item.extraLabel }})</ng-container></span>
    </button>
    <button mat-menu-item (click)="buildInfo()">
      <mat-icon class="material-icons-outlined" fontIcon="merge"></mat-icon>
      <span>{{ 'VERSION' | translate}}</span>
    </button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout()">
      <mat-icon class="material-icons-outlined" fontIcon="logout"></mat-icon>
      <span>{{ 'LOGOUT' | translate}}</span>
    </button>
  </mat-menu>
</mat-toolbar>
